"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.Paginate = void 0;

var _react = require("react"),
    _react2 = _interopRequireDefault(_react),
    _Stack = require("office-ui-fabric-react/lib/Stack"),
    _Button = require("office-ui-fabric-react/lib/Button");

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}

var Paginate = exports.Paginate = _react2.default.memo(function (a) {
  var b = a.contentOptionsPrefix,
      c = a.contentOptions,
      d = a.onSelect,
      e = a.content,
      f = a.back,
      g = a.fwd,
      h = a.disableBack,
      i = a.disableFwd,
      j = a.forceBackFwd,
      k = a.precontent,
      l = k === void 0 ? null : k,
      m = a.postcontent,
      n = m === void 0 ? null : m,
      o = j !== void 0 && j || !!c && 1 < c.length;
  return _react2.default.createElement(_Stack.Stack, {
    horizontal: !0,
    horizontalAlign: "space-between"
  }, _react2.default.createElement(_Stack.Stack.Item, null, o && _react2.default.createElement(_Button.ActionButton, {
    disabled: h !== void 0 && h,
    onClick: f,
    iconProps: {
      iconName: "ChevronLeft"
    }
  })), _react2.default.createElement(_Stack.Stack.Item, null, l, c ? _react2.default.createElement(_Button.ActionButton, {
    text: _react2.default.createElement(_react2.default.Fragment, null, !!b && b, e),
    menuProps: 1 < c.length && {
      items: c,
      onItemClick: function c(a, b) {
        return d(b.key);
      }
    }
  }) : _react2.default.createElement("div", {
    style: {
      padding: 10
    }
  }, e), n), _react2.default.createElement(_Stack.Stack.Item, null, o && _react2.default.createElement(_Button.ActionButton, {
    disabled: i !== void 0 && i,
    onClick: g,
    iconProps: {
      iconName: "ChevronRight"
    }
  })));
});